import { useCallback } from 'react'

import { useAppDispatch, useAppSelector } from 'store/store'

import * as gameActions from '../game/actions'
import * as leagueActions from '../league/actions'
import * as newsActions from '../news/actions'
import * as teamActions from '../team/actions'
import { actions } from './slice'

export const useApp = () => {
  const dispatch = useAppDispatch()
  const appState = useAppSelector(({ app }) => app)

  const setIsSignInModalOpen = useCallback(
    (visible: boolean) => {
      dispatch(actions.setIsSignInModalOpen(visible))
    },
    [dispatch],
  )

  const setIsSignUpModalOpen = useCallback(
    (visible: boolean) => {
      dispatch(actions.setIsSignUpModalOpen(visible))
    },
    [dispatch],
  )

  const setIsPostModalOpen = useCallback(
    (visible: boolean) => {
      dispatch(actions.setIsPostModalOpen(visible))
    },
    [dispatch],
  )

  const setIsProfileEditModalOpen = useCallback(
    (visible: boolean) => {
      dispatch(actions.setIsProfileEditModalOpen(visible))
    },
    [dispatch],
  )

  const setIsCreateTeamModalOpen = useCallback(
    (visible: boolean) => {
      dispatch(actions.setIsCreateTeamModalOpen(visible))
    },
    [dispatch],
  )

  const setIsCreateCommunityModalOpen = useCallback(
    (visible: boolean) => {
      dispatch(actions.setIsCreateCommunityModalOpen(visible))
    },
    [dispatch],
  )

  const setIsCreateGameModalOpen = useCallback(
    (visible: boolean) => {
      dispatch(actions.setIsCreateGameModalOpen(visible))
    },
    [dispatch],
  )

  const setIsCreateTournamentModalOpen = useCallback(
    (visible: boolean) => {
      dispatch(actions.setIsCreateTournamentModalOpen(visible))
    },
    [dispatch],
  )

  const setIsLoaderForTournament = useCallback(
    (visible: boolean) => {
      dispatch(actions.setIsLoaderForTournament(visible))
    },
    [dispatch],
  )
  const setIsSuccessTournamentModalOpen = useCallback(
    (visible: boolean) => {
      dispatch(actions.setIsSuccessTournamentModalOpen(visible))
    },
    [dispatch],
  )
  const setIsEndTournamentModalOpen = useCallback(
    (visible: boolean) => {
      dispatch(actions.setIsEndTournamentModalOpen(visible))
    },
    [dispatch],
  )

  const setTournamentCommunityContext = useCallback(
    (context: { communityId: string; communityName: string } | null) => {
      dispatch(actions.setTournamentCommunityContext(context))
    },
    [dispatch],
  )

  const getInitialData = useCallback(() => {
    // Check if data was recently fetched to avoid burst of calls on navigation
    const lastFetch = sessionStorage.getItem('initialDataFetch')
    const now = Date.now()

    // Only fetch if more than 5 minutes since last fetch
    if (!lastFetch || now - parseInt(lastFetch) > 300000) {
      sessionStorage.setItem('initialDataFetch', now.toString())

      // Stagger API calls to prevent rate limiting burst
      // Only fetch critical data immediately (games needed for tournament display)
      dispatch(gameActions.getAllGames())

      // Delay non-critical data fetches
      setTimeout(() => dispatch(leagueActions.getAllLeagues()), 500)
      setTimeout(() => dispatch(teamActions.getAllTeams()), 1000)
      setTimeout(() => dispatch(newsActions.getAllNews()), 1500)
      setTimeout(() => dispatch(newsActions.getMediumPosts()), 2000)
    }
  }, [dispatch])

  return {
    ...appState,
    setIsSignInModalOpen,
    setIsSignUpModalOpen,
    setIsPostModalOpen,
    setIsProfileEditModalOpen,
    setIsCreateTeamModalOpen,
    setIsCreateCommunityModalOpen,
    setIsCreateGameModalOpen,
    setIsCreateTournamentModalOpen,
    getInitialData,
    setIsLoaderForTournament,
    setIsSuccessTournamentModalOpen,
    setIsEndTournamentModalOpen,
    setTournamentCommunityContext,
  }
}
